import { useTranslation } from 'react-i18next';
import { InteracWordmark, InteracWordmarkType } from 'vopay';

// Interac rails must render through the branded wordmark rather than plain text, so the
// TransactionType key maps to the wordmark variant that spells out its full rail label.
const INTERAC_WORDMARKS: Record<string, InteracWordmarkType> = {
  'Interac Money Request': 'moneyRequest',
  'Interac Bulk Payout': 'bulkPayout',
  'Inbound e-Transfer': 'inbound',
  'Pay By Bank': 'embedded',
};

export type TransactionTypeLabelProps = {
  transactionType: string;
};

/**
 * Renders a transaction type the way the customer should see it: the Interac wordmark for
 * Interac rails, otherwise the shared Global.TransactionTypes label. Use this anywhere a
 * TransactionType is displayed so no surface drifts from the others.
 */
export default function TransactionTypeLabel({ transactionType }: TransactionTypeLabelProps) {
  const { t } = useTranslation('translations');
  const wordmark = INTERAC_WORDMARKS[transactionType];

  if (wordmark) return <InteracWordmark type={wordmark} />;

  return <>{t(`Global.TransactionTypes.${transactionType}`, { defaultValue: transactionType })}</>;
}
